import React, {ReactElement, useEffect, useState, useRef} from 'react';
import {useHistory} from 'react-router-dom';
import {useDispatch} from 'react-redux';
import TourModal from '../../components/modal/MidScreenModal';
import {useAppSelector} from '../../redux/hooks';
import {fetchBanners, bannerResponse} from '../../redux/homeSlice';
import eliteMembershipImg from '../../assets/images/aftermembership.jpg';
import nonEliteMembershipImg from '../../assets/images/beforemembership.jpg';
import unlockOfferLockIcon from '../../assets/images/unlock.svg';
import topNavOffersIcon from '../../assets/images/top_nav_offers_small.svg';
import Slider from 'react-slick';
import {
  bannerEvent,
  EliteAlphaNumStoreCode,
  EliteEnableStatus,
  EliteNumericStoreCode,
  eventNames,
  pageName,
  qrCodeEvent,
  tourGuideGif,
} from '../../lib/constants';
import {
  setPageName,
  userAttributes,
  setUserUniqueId,
  bannerDetailGtmData,
  loginMoengageEvent,
  storeCodeGtmData,
  setLmrFirstVisistStatus,
  setlmrStatus,
} from '../../lib/tagmanager';
import {
  getAccessToken,
  getPhoneNumber,
  setCustomerCouponsCountinLS,
  setSearchUser,
  getUserType,
  getMoengageData,
  getStoreInformation,
  //  setTourGuide,
  getLmrFirstStatus,
  getLmrUserStatus,
  getLandedFirstTimeCount,
  setLandedFirstTimeCount,
  getCustomerCouponsCountinLS,
  getAllOffers,
  getCouponPointsDetails,
  CustomerCoupon,
  setOrderResp,
  getUser,
  getStoreCode,
} from '../../core/localstorage-data';
import {tourGuide, setTourGuide} from '../../redux/tourGuideSlice';
import rightCursorArrow from '../../assets/images/right_cursor_arrow.svg';
import Banner from './banner/index';
import Grid from './grid';
import {
  bannerDetailInfo,
  bannerType,
  homeGridItemType,
  storeDetailInfo,
} from '../../lib/types';
import Modal from '../../components/modal/Modal';
import {
  customerProfile,
  fetchCustomerProfile,
} from '../../redux/customerSearchSlice';
import {
  couponPoints,
  offers,
  resetCouponAPIResponse,
  setCustomerCouponsCount,
  resetOfferState,
} from '../../redux/offerSlice';
import {getWithExpiry, setWithExpiry} from '../../core/localstorage-utils';
import './Home.css';
import Lottie from 'react-lottie';
import {logout} from '../../core/utils/routing.util';
import {setIsUserElite, isUserElite} from '../../redux/globalSlice';
import moment from 'moment';
import { eliteMembershipSubscription, fetchOrder, orderResponse } from '../../redux/orderSlice';
declare const window: any;
type offerType = {
  customerCouponId: number;
  mobileNumber: string;
  couponGeneratedTime: string;
  couponCode: string;
  description: string;
  validity: string;
  keyId: string;
  couponType: string;
  regionId: string;
  detailsId: number;
};
const HomePage = (): ReactElement => {
  const [openTourGuide, setOpenTourGuide] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedBanner, setSelectedBanner] = useState<bannerType | null>(null);
  const [banners, setBanners] = useState<bannerType[] | []>([]);
  const navigate = useHistory();
  const history = useHistory();
  const dispatch = useDispatch();
  const bannersData = useAppSelector(bannerResponse);
  const accessToken = getAccessToken();
  const customerProfileData = useAppSelector(customerProfile);
  const couponPointsDataFromAPI = useAppSelector(couponPoints);
  const orderResp = useAppSelector(orderResponse);
  const isUserEliteMember = useAppSelector(isUserElite);
  const tourGuideStatus = useAppSelector(tourGuide);
  const myOffers = useAppSelector(offers);
  const userType = getUserType();
  const slider = React.useRef(null);
  const moengateUserData = getMoengageData();
  const storeInformation = getStoreInformation();
  const alloffers = getCouponPointsDetails();
  const storeCode = `0${getStoreInformation().store_code}`;
  const numericStoreCode = getStoreInformation().store_code;
  const card_number = getUser().cardNumber;
  const storeId = getStoreCode();
  const [elitePopup, setElitePopup] = useState(true);
  const [offerPopup, setOfferPopup] = useState(false);
  const customerCouponsCount = useAppSelector(
    state => state.offerReducer.customerCouponsCount,
  );
  if (!customerCouponsCount) {
    const count = getCustomerCouponsCountinLS();
    if (count) {
      dispatch(setCustomerCouponsCount(count));
    }
  }

  const userEliteCount = getLandedFirstTimeCount();
  const [landedFirstTime, setLandedFirstTime] = useState(false);
  const [showElite,setShowElite] = useState(false);
  // const tourGuideStatus = getTourGuideStatus();
  const getStatus = getLmrFirstStatus();
  const lmrStatus = getLmrUserStatus();
  let mobile: string | null = null;
  mobile = getPhoneNumber();
  window.scrollTo(0, 0);
  const [firstName, setFirstName] = useState('');
  //console.log('first Name');
  if (userType === null) {
    logout();
  }
  useEffect(() => {
    setPageName(pageName.homePage);
  }, []);

  useEffect(() => {
    let count=0;
    EliteNumericStoreCode.map(storecode => {
      if (storecode === numericStoreCode && EliteEnableStatus === true) {
        setShowElite(true);
        count++;  
      }
    });
    EliteAlphaNumStoreCode.map(storecode => {
      if (storecode === storeId && EliteEnableStatus === true) {
        setShowElite(true);
        count++;
      }
    });
    if (customerProfileData.tier !== 'ELITE' || count===0) {
      setOfferPopup(true);
    }
    setTimeout(() => {
      setLandedFirstTime(userEliteCount === 0 ? true : false);
    }, 1000);
  }, []);

  useEffect(() => {
    if (tourGuideStatus) {
      setTimeout(() => {
        setOpenTourGuide(true);
      }, 1000);
    }
  }, [tourGuideStatus]);

  useEffect(()=>{
    if(orderResp!==null){
      setOrderResp(orderResp);
    }
  },[orderResp])

  useEffect(() => {
    const couponsInLS = getWithExpiry('coupon_point_details');
    if (couponsInLS) {
      dispatch(setCustomerCouponsCount(couponsInLS.length));
      setCustomerCouponsCountinLS(couponsInLS.length);
    }
    let allOffers;
    if (myOffers !== null) {
      const updateMyOffers = myOffers.map(offer => {
        return {
          ...offer,
          description: offer.couponDesc,
          validity: offer.validTillDate,
        };
      });
      if (couponsInLS && couponsInLS.length > 0) {
        //       const changedCoupons = checkIsCouponExisting(updateMyOffers);
        allOffers = [...couponsInLS, ...updateMyOffers];
      } else {
        allOffers = [...updateMyOffers];
      }
      // allOffers.sort((a, b) => (a.validity > b.validity ? 1 : -1));
      // const updatedOffers = allOffers.map(offer => {
      //   if (offer.description.includes('_.')) {
      //     const description = offer.description.split('_.')[1].trim();
      //     return {...offer, description};
      //   }
      //   return offer;
      // });
      setWithExpiry('coupon_point_details', allOffers);
      dispatch(setCustomerCouponsCount(allOffers.length));
      setCustomerCouponsCountinLS(allOffers.length);
      dispatch(resetOfferState());
    }
  }, [myOffers]);

  useEffect(() => {
    if (customerProfileData.firstName != null) {
      const userFirstName = customerProfileData.firstName;
      const name = userFirstName.trim();

      setFirstName(name);
    }
    if (customerProfileData.firstName === null) {
      setFirstName(' ');
    }
  }, [customerProfileData]);

  const buttonHandler = (currentPage: number) => {
    console.log(currentPage);
    console.log(tourGuideGif.length);
    if (tourGuideGif.length == currentPage) {
      dispatch(setTourGuide(false));
      setOpenTourGuide(false);
      setCurrentPage(1);
      return;
    }
    console.log(slider.current);
    slider?.current?.slickNext();
    setCurrentPage(prevState => prevState + 1);
  };

  useEffect(() => {
    setOrderResp(null);
    if (couponPointsDataFromAPI !== null) {
      dispatch(resetCouponAPIResponse());
    }
    dispatch(fetchBanners());
    if (accessToken) {
      const parameters = {
        payload: {
          source: 'MAXBUDDY',
          locationCode: 'BNG',
          mobileNumber: mobile,
        },
        accessToken: accessToken,
      };

      dispatch(fetchCustomerProfile(parameters));
    }
  }, []);

  useEffect(()=>{
    const orderParameters = {
      accessToken: accessToken,
      payload: {
        storeCode: storeCode,
        cardNumber: card_number,
        storeKeyId: storeId,
      },
    };
    //dispatch orderID api call
    dispatch(fetchOrder(orderParameters));
  },[])

  useEffect(() => {
    if (customerProfileData && customerProfileData.result === true) {
      // const orderParameters = {
      //   accessToken: accessToken,
      //   payload: {
      //     storeCode: storeCode,
      //     cardNumber: card_number,
      //     storeKeyId: storeId,
      //   },
      // };
      // //dispatch orderID api call
      // dispatch(fetchOrder(orderParameters));
      if (moengateUserData === null) {
        if (mobile !== null && storeInformation != null) {
          if (getStatus != null) {
            setLmrFirstVisistStatus(true);
            localStorage.removeItem('_storeStatus');
          }
          if (getLmrUserStatus != null) {
            setlmrStatus(true);
            localStorage.removeItem('_userStatus');
          }
          const storeDetail: storeDetailInfo = {
            storecode: storeInformation.store_code,
            storeaddress: storeInformation.store_name,
            storecitypincode: storeInformation.pincode,
            store_name: storeInformation.store_name,
            entity: storeInformation.entity,

            event: qrCodeEvent,
          };
          storeCodeGtmData(storeDetail);
          setUserUniqueId(mobile);

          loginMoengageEvent(mobile, customerProfileData.cardNumber);

          userAttributes(customerProfileData, mobile);
        }
      }
      if (customerProfileData.tier === 'ELITE') {
        dispatch(setIsUserElite(true));
      } else {
        dispatch(setIsUserElite(false));
      }
      setSearchUser(customerProfileData);
    } else {
      //history.push('/login');
    }
  }, [customerProfileData]);

  useEffect(() => {
    if (bannersData.images) {
      const bannerList = Object.keys(bannersData.images)
        .filter(img => !img.endsWith('_content'))
        .map(img => ({
          src: bannersData.images[img],
          content: bannersData.images[`${img}_content`],
        }));
      setBanners(bannerList);
    }
  }, [bannersData]);
  const gridItemClickHandler = (item: homeGridItemType) => {
    console.log(item);
    if (item.url !== '') {
      history.push(item.url);
    }
  };

  const bannerClickHandler = (banner: bannerType) => {
    setSelectedBanner(banner);
    if (banner != null) {
      const bannerFilter = (banner?.content).lastIndexOf('/') + 1;
      const bannerNameWithExtension = (banner?.content).slice(bannerFilter);
      const bannerNameWithoutExtension = bannerNameWithExtension.split('.');

      const BannerDetail: bannerDetailInfo = {
        bannerId: bannerNameWithoutExtension[0].toString(),
        eventName: eventNames.inStoreEvent,
        event: bannerEvent,
      };
      eventNames.inStoreEvent;
      bannerDetailGtmData(BannerDetail);
    }
  };

  const exitHandler = () => {
    setCurrentPage(1);
    dispatch(setTourGuide(false));
    setOpenTourGuide(false); //setIsConfirmationModal(false);
  };

  // for elite functionality
  const handleEnrollElite = async () => {
    if (storeCode && storeId) {
      const parameters = {
        accessToken,
        payload: {
          storeCode,
          storeKeyId : storeId,
        },
      };
      await dispatch(eliteMembershipSubscription(parameters));
      navigate.push('/checkout/shoppingbag');
    }
  }

  return (
    <div className="bg-white overflow-y-auto home-height">
      <div className="pt-6 px-4">
        <div className="text-sm mb-4">
          Hello!&nbsp;
          <span className="font-bold">{firstName} &nbsp;</span>
        </div>
        <Grid onGridItemClick={gridItemClickHandler} />
      </div>
      <Banner banners={banners} onBannerClick={bannerClickHandler} />
      <div className="mt-6 flex items-center px-4 mb-4 home-in-store-container">
        <a className="flex items-center justify-between font-medium py-4 px-4 w-full rounded-3xl bg-blue_two font-roboto home-in-store-link">
          <div className="flex flex-col">
            <div className="text-black_zero text-opacity-50 text-xxs font-bold">
              EXPLORE
            </div>
            <div className="font-medium text-base text-black_zero">
              View all in-store promotions
            </div>
          </div>
          <div className="bg-white rounded-2xl px-2.5 py-1">
            <a onClick={() => navigate.push('/home/in-store-promotions')}>
              <img src={rightCursorArrow} alt="In store promotions" />
            </a>
          </div>
        </a>
      </div>
      {selectedBanner !== null && (
        <Modal
          title=""
          isVisible={selectedBanner !== null}
          onModalClosed={() => {
            setSelectedBanner(null);
          }}>
          <div className="w-full h-auto pl-8 pr-8">
            <img src={selectedBanner.content} alt="Banner" />
          </div>
        </Modal>
      )}
      {/* <ConfirmModal
        title="Website Overview"
        message="Do you want to take a tour of website"
        onClose={modalCloseHandler}
        open={isConfirmationModal}
        onCancel={modalCloseHandler}
        onConfirm={modalConfirmHandler}
      /> */}

      {openTourGuide ? (
        <TourModal
          isVisible
          className="tour-modal"
          crossVisible={false}
          onClose={() => {
            console.log('a');
          }}>
          <>
            <div className="content-box">
              <Slider
                ref={slider}
                dots={false}
                slidesToShow={1}
                slidesToScroll={1}
                swipe={false}
                autoplay={false}
                autoplaySpeed={3000}
                adaptiveHeight
                arrows={false}
                centerMode
                centerPadding="1px">
                {tourGuideGif.map((tourguide, index) => (
                  <div key={index}>
                    {index == 0 ? (
                      <div>
                        <div className="tour-height pt-40">
                          <p className="text-big text-center font-roboto tracking-normal leading-9 font-light">
                            Buddy Tour
                          </p>
                          <br />
                          <p className="font-roboto text-center text-small   text-black_zero text-opacity-50 tracking-very_very_tightest">
                            Do you want to take a tour of Buddy and learn how to
                            unlock coupons and self checkout?
                          </p>
                        </div>
                      </div>
                    ) : (
                      <div>
                        <Lottie options={tourguide} />
                      </div>
                    )}
                  </div>
                ))}
              </Slider>
            </div>
            <div className="border-t border-light_grey border-opacity-10">
              <button
                className="pt-4 w-1/2 text-black_zero font-bold font-roboto focus:outline-none"
                onClick={exitHandler}>
                {currentPage === 1 ? <p>No Thanks </p> : <p>Exit </p>}
              </button>
              <button
                className="pt-4  w-1/2 border-l border-light_grey font-roboto border-opacity-10 text-royal_blue font-bold focus:outline-none "
                onClick={() => buttonHandler(currentPage)}>
                {currentPage === 1 ? <p>Take tour </p> : <p>Got it </p>}
              </button>
            </div>
          </>
        </TourModal>
      ) : (
        ''
      )}
      {landedFirstTime && !isUserEliteMember && !openTourGuide && elitePopup && showElite && (
        <TourModal
          isVisible
          onClose={() => {
            if (customerCouponsCount > 0) {
              setOfferPopup(true);
              setElitePopup(false);
            } else {
              setLandedFirstTime(false);
              setLandedFirstTimeCount(1);
            }
          }}>
          <div className="overflow-x-hidden p-4 overflow-y-hidden ">
            <div
              className={`w-72 offer-view flex flex-col items-center justify-center`}>
              <img
                src={
                  isUserEliteMember ? eliteMembershipImg : nonEliteMembershipImg
                }
                alt="image"
              />
            </div>
            <div>
              <button
                className="text-white h-11 rounded-radius10 mt-2 grid place-items-center focus:outline-none text-center primary normal w-100"
                onClick={handleEnrollElite}>
                Enrol @ Rs499 ONLY
              </button>
            </div>
          </div>
        </TourModal>
      )}
      {customerCouponsCount > 0 &&
        offerPopup &&
        landedFirstTime &&
        !openTourGuide && (
          <TourModal
            isVisible
            onClose={() => {
              setLandedFirstTime(false);
              setLandedFirstTimeCount(1);
            }}
            //animate={true}
            //animateDirection={ModalAnimateDirection.RIGHT_TO_LEFT}
          >
            <div className="overflow-x-hidden p-4 overflow-y-scroll h-96">
              <div
                className={`w-72 offer-view flex flex-col items-center justify-center`}>
                <div className="">
                  <img src={unlockOfferLockIcon}></img>
                  {/* <div className="text-base font-bold">{offer?.type}</div> */}
                  {/* <div className="text-sm mt-0.5">{offer?.discount}</div> */}
                </div>
                <div className="mt-5 w-full">
                  <div className="text-xl mb-5">Your offer unlocked!</div>
                  <div className="font-bold font-roboto  flex justify-center">
                    <span>These coupons will be stored in</span>
                    <span>
                      <img src={topNavOffersIcon} />
                    </span>
                  </div>
                  <div className="text-xs">
                    Redeem at self checkout or billing counter
                  </div>
                </div>
              </div>
              <div className={`transition transform view-wrapper-coupon`}>
                {/* style={{...animateStyles}}> */}
                {alloffers.value.length > 0 &&
                  alloffers.value.map((data, index) => (
                    <div key={index} className="float-left divide-y">
                      <OfferView offer={data} />
                      {index !== alloffers.value.length - 1 ? (
                        <div></div>
                      ) : (
                        <></>
                      )}
                    </div>
                  ))}

                <div className="clear-both"></div>
              </div>
              {/* <div
              className=" mt-5 text-red-600 font-roboto font-bold"
              onClick={onTncClick}>
              T&C Apply
            </div> */}
            </div>
          </TourModal>
        )}
    </div>
  );
};

interface OfferViewProps {
  offer?: offerType | null;
}

const OfferView = ({offer}: OfferViewProps): ReactElement => {
  const getValidity = (validity: string | undefined) => {
    return moment(validity).format('YYYY-MM-DD HH:mm:ss');
  };
  return (
    <div
      className={`w-72 offer-view flex flex-col items-center justify-center`}>
      <div className="mt-5 w-full">
        <div className="mt-4 border-2 border-dotted shadow-md rounded-xl border-very_light_purple w-full py-3 text-lg font-medium bg-very_light_gray">
          {offer?.couponCode}
        </div>
        <div className="mt-4 mb-2">{offer?.description}</div>
        <div className="text-tiny m-1.5 text-royal_blue mb-6">
          <span className="">Valid till:&nbsp;</span>
          <span className="">{getValidity(offer?.validity)}</span>
        </div>
      </div>
      {/* <div
        className=" mt-5 text-red-600 font-roboto font-bold"
        onClick={onTncClick}>
        T&C Apply
      </div> */}
    </div>
  );
};

export default HomePage;
